import ShowLocation from './showLocation';

export default ShowLocation;
